import React from "react";
import { useLang } from "../context/LanguageContext";

const MobileBottomMenu = ({
  title,
  withTabs,
  sectionIndex = 0,
  sectionCount = 1,
  onPrev,
  onNext,
}) => {
  const { lang } = useLang();
  const showNavButtons = withTabs && sectionCount > 1;
  const wrapperClass = showNavButtons
    ? "mobileBottomMainDiv mobileBottomWithTabs"
    : "mobileBottomMainDiv";
  const isRtl = lang === "ar";
  const handlePrev = isRtl ? onNext : onPrev;
  const handleNext = isRtl ? onPrev : onNext;

  return (
    <div
      className={wrapperClass}
      dir={isRtl ? "rtl" : "ltr"}
    >
      {showNavButtons && (
        <button
          type="button"
          className="mobileBottomNavButton"
          aria-label="Previous tab"
          onClick={handlePrev}
        >
          <span className="iconDiv">
            <span style={{ fontSize: "28px", fontWeight: 900 }}>
              {lang === "en" ? "❮" : "❯"}
            </span>
          </span>
        </button>
      )}
      <p>
        {showNavButtons ? (
          <>
            {lang === "ar"
              ? `${(sectionIndex + 1).toLocaleString("ar-EG")}. ${title}`
              : `${sectionIndex + 1}. ${title}`}
          </>
        ) : (
          title
        )}
      </p>
      {showNavButtons && (
        <button
          type="button"
          className="mobileBottomNavButton"
          aria-label="Next tab"
          onClick={handleNext}
        >
          <span className="iconDiv">
            <span style={{ fontSize: "28px", fontWeight: 900 }}>
              {lang === "en" ? "❯" : "❮"}
            </span>
          </span>
        </button>
      )}
    </div>
  );
};

export default MobileBottomMenu;
